import React, { useState } from 'react'
import Reviews from '../../../components/Front/Reviews/Reviews'
import OnlinePkBanner from '../../../assets/images/front/online-pk-5-banner.png'
import OnlinePkBannerMobile from '../../../assets/images/front/online-pk-5-banner-mobile.png'
import OnlinePk5BannerGraphics from '../../../assets/images/front/svg/online-pk-9-banner-graphics.svg'
import OnlinePk5BannerButton from '../../../assets/images/front/svg/online-pk-5-button.svg'
import Image249 from '../../../assets/images/front/249.png'
import ImageHand from '../../../assets/images/front/ruka.png'
import ArrowWhiteRight from '../../../assets/images/front/svg/arrow-right-white.svg'
import SkolaBannerSecondary from '../../../assets/images/front/skola-banner-secondary.png'
import SkolaBannerSecondaryMobile from '../../../assets/images/front/skola-banner-secondary-mobile.png'
import MatematikaImage from '../../../assets/images/front/svg/matematika.svg'
import CeskyImage from '../../../assets/images/front/svg/cesky.svg'
import { useHistory } from 'react-router-dom'
import { routesURLs } from '../../../Routes'
import { useQuery } from 'react-query'
import { getAllClasses, getOnlineCoursesByClass } from '../../../moduls/online-courses'
import { LessonClassType, OnlineCourseType } from '../../../services/types'

const Pk9Online: React.FC = () => {
  const history = useHistory()
  const [showCourseOptions, setShowCourseOptions] = useState(false)
  const toggleCourseOptions = () => {
    setShowCourseOptions((prev) => !prev)
  }

  const { data: classes } = useQuery(['classes'], getAllClasses)
  const currentClass = classes?.find(
    (cls: LessonClassType) => cls.name === 'PŘÍPRAVA NA PŘIJÍMAČKY 9. TŘÍDA'
  )
  const { data: availableOnlineCourses } = useQuery(
    ['online-courses', { lessonId: currentClass?.id }],
    getOnlineCoursesByClass
  )

  return (
    <>
      <div className="container relative mx-auto md:px-4 mt-[52px] lg:mt-[84px]">
        <img
          src={OnlinePkBanner}
          alt=""
          className="w-full min-h-[350px] h-auto hidden md:block object-cover rounded-b-3xl"
        />
        <img
          src={OnlinePkBannerMobile}
          alt=""
          className="w-full min-h-[350px] h-auto md:hidden object-cover"
        />
        <div className="absolute left-[50%] translate-x-[-50%] md:translate-x-0 md:left-8 top-4 w-[calc(100%-16px)] md:w-full px-4">
          <img
            src={OnlinePk5BannerGraphics}
            alt=""
            className="w-full max-w-[585px] h-auto object-cover"
          />
        </div>
        <div className="absolute right-[-50%] translate-x-[-50%] md:translate-x-0 bottom-10 md:right-20 md:bottom-20 px-8 md:px-0 block w-full md:w-auto">
          <span
            onClick={() => toggleCourseOptions()}
            className={`${
              showCourseOptions ? 'rounded-t-xl' : 'rounded-xl'
            } cursor-pointer w-full text-center md:w-auto md:text-start inline-block text-2xl md:text-5xl pt-3 text-white bg-[#A8CD00] hover:bg-[#8FB200] tracking-wide leading-tight px-10 py-2 transition-colors duration-200 relative`}
          >
            KOUPIT KURZ
            <img
              src={OnlinePk5BannerButton}
              alt=""
              className="absolute top-[30%] translate-y-[-50%] -right-10 w-[100px] hidden md:block"
            />
            <img src={Image249} alt="" className="absolute w-[60px] -top-10 -right-8 md:hidden" />
            <img
              src={ImageHand}
              alt=""
              className="absolute w-[60px] -bottom-9 left-[50%] translate-x-[-50%] md:hidden"
            />
          </span>
          {showCourseOptions && (
            <div className="border border-[#A8CD00] rounded-b-xl bg-white px-2 py-3 w-full">
              {availableOnlineCourses && availableOnlineCourses.length > 0
                ? availableOnlineCourses.map((course: OnlineCourseType) => {
                    return (
                      <div key={course.id}>
                        <span
                          className="cursor-pointer transition-all duration-300 hover:text-[#A8CD00]"
                          onClick={() =>
                            history.push(
                              routesURLs.onlineCourses +
                                `/${course.subject.id}/${course.lesson_class.id}`
                            )
                          }
                        >
                          {course.subject.name}
                        </span>
                      </div>
                    )
                  })
                : 'Žádné kurzy nejsou k dispozici'}
            </div>
          )}
        </div>
      </div>
      <div className="container relative mx-auto md:px-4 mt-[52px] lg:mt-[84px]">
        <div className="grid grid-cols-12 gap-4 mb-[30px] lg:mb-[50px] px-4 lg:px-0">
          <div className="col-span-12 lg:col-span-6">
            <h3 className="text-[25px] text-[#0183BA] mb-3 md:mb-2">
              ON-LINE PŘÍPRAVNÝ KURZ K PŘIJÍMACÍM ZKOUŠKÁM
            </h3>
            <p className="mb-4">
              Nabízíme Vám komplexní přípravný kurz k přijímacím zkouškám na víceletá gymnázia z
              matematiky i českého jazyka. V kurzu Vás čeká vysvětlení (výuková videa) a procvičení
              (interaktivní cvičení a pracovní listy) veškeré látky, která je obsahem jednotné
              přijímací zkoušky od společnosti CERMAT.
            </p>
            <p className="mb-4">
              Kurz je zaměřený na úlohy, které jsou obsahem přijímacích testů. Veškeré učivo žákům
              podáváme co nejjednodušší formou v logicky navazujících blocích. Studenti seznámí s
              typem otázek a cvičení, které se v testech objevují a naučí se je efektivně řešit.
            </p>
            <p>
              Po absolvování kurzu budou vědět, co je u přijímaček čeká, a nic je u zkoušky
              nezaskočí.
            </p>
          </div>
          <div className="col-span-12 lg:col-span-6 py-6 px-8 bg-[#00A0E3] rounded-3xl text-white">
            <h3 className="text-white text-lg lg:text-[25px] leading-tight mb-5">
              VÝHODY ON-LINE PŘÍPRAVNÉHO KURZU
            </h3>
            <ul className="font-myriad is-pure-list">
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                neomezený přístup k celému obsahu po celý školní rok
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                trénovat můžete kdekoliv, stačí pouze připojení k internetu
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                okamžité vyhodnocení a pravidelná zpětná vazba pro rodiče
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                přes sto výukových videí
              </li>
              <li className="flex items-start mb-1">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                více než sedm set testových otázek
              </li>
              <li className="flex items-start">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />
                desítky pracovních listů
              </li>
              <li className="flex items-start">
                <img src={ArrowWhiteRight} alt="" className="mt-1 me-1" />V KAŽDÉM KURZU NĚKOLIK
                LEKCÍ ZDARMA
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 mb-[30px] lg:mb-[50px]">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12">
            <h2 className="text-[25px] text-[#0183BA] text-center">
              on-line Přípravný kurz - ČTYŘLETÉ OBORY
            </h2>
          </div>
          {availableOnlineCourses && availableOnlineCourses.length > 0 ? (
            availableOnlineCourses.map((course: OnlineCourseType) => {
              return (
                <div className="col-span-12 lg:col-span-6">
                  <span
                    onClick={() =>
                      history.push(
                        routesURLs.onlineCourses + `/${course.subject.id}/${course.lesson_class.id}`
                      )
                    }
                    className="cursor-pointer text-xl lg:text-5xl text-white rounded-xl border bg-[#A8CD00] hover:bg-[#8FB200] transition-all duration-300 border-[#A8CD00] ps-24 pe-4 pt-3 py-2 flex items-center w-full bg-left bg-no-repeat"
                    style={{
                      backgroundImage: `url(${
                        course.subject.name === 'matematika' ? MatematikaImage : CeskyImage
                      })`,
                      backgroundSize: '80px'
                    }}
                  >
                    {course.subject.name}
                  </span>
                </div>
              )
            })
          ) : (
            <div className="col-span-12">
              <p>Žádné kurzy nejsou k dispozici</p>
            </div>
          )}
        </div>
      </div>
      <div className="px-4">
        <div className="container relative mx-auto">
          <img src={SkolaBannerSecondary} alt="" className="hidden md:block rounded-t-3xl" />
          <img src={SkolaBannerSecondaryMobile} alt="" className="block md:hidden rounded-t-3xl" />
          <div className="grid grid-cols-12 gap-4 absolute top-5 left-8 pe-8 md:left-12">
            <div className="col-span-12 md:col-span-9 lg:col-span-6 flex flex-col">
              <h3 className="text-[25px] text-[#0183BA] mb-3 md:mb-2">
                VYZKOUŠEJTE SI ON-LINE KURZY ZDARMA
              </h3>
              <div className="mb-6 md:mb-3 leading-tight">
                <p className="mb-4 md:mb-3">
                  Vyberte si kurz a přidejte do košíku lekce označené „Po registraci zdarma“. <br />
                  Stačí pak jen vyplnit krátkou registraci a lekce se vám okamžitě zpřístupní.
                </p>
                <p>
                  🎯 Vyzkoušejte si kurz naplno a zjistěte, jestli vám sedí. <br />
                  📚 Pokud ano, můžete si kdykoliv dokoupit celý kurz nebo jen vybrané lekce.
                </p>
              </div>
              <span
                onClick={() => history.push(routesURLs.onlineCourses)}
                className="inline-block text-white leading-tight text-[25px] bg-[#00A0E3] rounded-xl pt-3 py-2 px-4 transition-colors duration-200 mx-auto md:ms-auto md:me-10"
              >
                vyzkoušet kurz zdarma
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="-mb-12">
        <div className="HP">
          <Reviews />
        </div>
      </div>
    </>
  )
}

export default Pk9Online
